import { IGetDashboardProjetosInfoUseCase } from "../../../presentation/useCases/read/get_dashboard_projetos_info_use_case";
import { DashboardProjetosInfo } from "../../models/dashboard_projetos_info";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * GetDashboardProjetosInfoUseCase
 */

export class GetDashboardProjetosInfoUseCase implements IGetDashboardProjetosInfoUseCase {
  constructor(private readonly repository: IProjetosRepository) { }

  async execute(): Promise<DashboardProjetosInfo> {
    return await this.repository.getDashboardProjetosInfo();
  }

}
